import { render, staticRenderFns } from "./HrDocumentPreviousVersionDialog.vue?vue&type=template&id=0fb28766&"
import script from "./HrDocumentPreviousVersionDialog.vue?vue&type=script&lang=js&"
export * from "./HrDocumentPreviousVersionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports